import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem } from "@mui/material";
import { Route, Routes } from 'react-router-dom'
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../redux/slice/user";
import api from "../../API";
import GroupIcon from '@mui/icons-material/Group';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import RuleIcon from '@mui/icons-material/Rule';
import { SearchBackDrop } from "../component/common/SearchBackDrop";
import VieWorkerPage from "./VieWorkerPage";
import VieWorkerMenuPage from "./VieWorkerMenuPage";
import VieWorkerCreatePage from "./create/VieWorkerCreatePage";


const VieWorkerRouter = (props:any) => {

  return (
    <Box>
      <Routes>
        {/* <Route path="main" element={<MainPage />} /> */}
        <Route path="/create" element={<VieWorkerCreatePage />} />
        <Route path="/ref" element={<VieWorkerPage />} />
        <Route path="/prc" element={<VieWorkerPage />} />
        {/* <Route path="/trans" element={<TzaWorkerTransPage />} /> */}
        <Route path="/isp" element={<VieWorkerPage />} />
        <Route path="*" element={<VieWorkerMenuPage />} />
      </Routes>
    </Box>
  );
};

export default VieWorkerRouter;
